import types from './types';
import { getErrorMessage } from '../../utils';
import { t } from 'i18next';

export default ({ type, request, data }) => {
  switch (type) {
    case types.CREATE_NEW_DATAVIEW_SUCCESS:
      return {
        title: t('message.title.success.save.dataview'),
        type: 'success'
      };
    case types.CREATE_NEW_DATAVIEW_FAILURE:
      return {
        title: t('message.title.error.save.dataview'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    case types.DELETE_DATAVIEW_SUCCESS:
      return {
        title: t('message.title.success.delete.dataview'),
        type: 'success'
      };
    case types.DELETE_DATAVIEW_FAILURE:
      return {
        title: t('message.title.error.delete.dataview'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    case types.SHARE_DATAVIEW_FAILURE:
      return {
        title: t('message.error.data.view.not.found'),
        message: t(getErrorMessage(data)),
        type: 'info'
      };
    case types.GET_FAVORITE_DATAVIEW_LIST_FAILURE:
      return {
        title: t('message.error.fetching.data.favorite.views'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    default:
      return false;
  }
};
